import { render } from "./OnboardingStatus.vue?vue&type=template&id=36aeafd6"
import script from "./OnboardingStatus.vue?vue&type=script&lang=js"
export * from "./OnboardingStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__